import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Moment } from 'moment';

export class CustomDateAdapter extends MomentDateAdapter {
  public previousDate: Moment | null = null;

  override parse(value: any, parseFormat: string | string[]): Moment | null {
    return super.parse(value, parseFormat);
  }

  override format(date: Moment): string {
    const startOfWeek = date.clone().startOf('isoWeek');
    const endOfWeek = date.clone().endOf('isoWeek');
    return `${startOfWeek.format('DD')}-${endOfWeek.format('DD')} ${endOfWeek.format('MMM')}`;
  }
}
